import { Query } from '@tanstack/react-query';

type GetUserAvatarPictureQuery = Query<
  Awaited<ReturnType<Api.Client['getUserAvatarPicture']>>,
  OP.ApiError
>;

/**
 * refetchInterval callback for getUserAvatarPicture queries.
 * Automatically refetches 5 minutes before the signed URL expires.
 * Only activates when expiresAt is present (private pictures).
 */
export const getUserAvatarPictureRefetchInterval = (
  query: GetUserAvatarPictureQuery,
): false | number => {
  const data = query.state.data?.json?.data;
  const expiresAt = data?.picture?.expiresAt;

  if (!expiresAt) return false;

  const now = Date.now();
  const expiryMs = expiresAt * 1000; // expiresAt is in seconds
  const fiveMinutesMs = 5 * 60 * 1000;

  // Calculate time until 5 minutes before expiry
  const refetchTimeMs = expiryMs - fiveMinutesMs;
  const timeUntilRefetch = refetchTimeMs - now;

  // If we're already past the refetch time, refetch immediately
  if (timeUntilRefetch <= 0) {
    return 0;
  }

  // Otherwise, return the exact time to wait before refetching
  return timeUntilRefetch;
};
